import React from "react";

import { Grid } from "@material-ui/core";

import {
  CheckboxGroupInput,
  minValue,
  number,
  NumberInput,
  RadioButtonGroupInput,
  required,
  SelectInput,
  TextInput,
} from "react-admin";

import { unitOptionRenderer } from "../../../utils/loadTypeUtils";
import {
  ActiveTrueOrFalse,
  InventoryFieldOptions,
  LocationLoadTypeOptions,
  TrueOrFalse,
  UnitOptions,
} from "../../../utils/constants";

const validateRequired = [required()];
const validateQtyRequired = [required(), number(), minValue(0)];

export const CommodityForm = (props) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6}>
        <TextInput
          source="name"
          label="Name"
          variant="outlined"
          fullWidth
          validate={validateRequired}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <NumberInput
          source="sortKey"
          label="Sort Key"
          variant="outlined"
          fullWidth
          validate={validateQtyRequired}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectInput
          source="defaultUnits"
          label="Default Units"
          variant="outlined"
          fullWidth
          choices={UnitOptions}
          optionText={unitOptionRenderer}
          initialValue="UNIT"
          validate={validateRequired}
        // onChange={() => utils.handleUnitChange(form, setCalcError)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectInput
          source="locationLoadType"
          label="Load Type"
          variant="outlined"
          fullWidth
          choices={LocationLoadTypeOptions}
          validate={validateRequired}
        // onChange={() => utils.handleUnitChange(form, setCalcError)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextInput
          source="description"
          label="description"
          variant="outlined"
          fullWidth
          validate={validateRequired}
        />
      </Grid>
      <Grid item xs={12}>
        <CheckboxGroupInput
          source="validUom"
          label="Valid UOM"
          row
          fullWidth
          choices={UnitOptions}
        />
      </Grid>
      <Grid item xs={12}>
        <CheckboxGroupInput
          source="inventoryFields"
          label="Inventory Fields"
          row
          fullWidth
          choices={InventoryFieldOptions}
          helperText="Additional Fields to display in Inventory Forms"
        />
      </Grid>
      <Grid item xs={12} md={6} align="left">
        <RadioButtonGroupInput
          source="enableCounter"
          label="Pre-Count"
          variant="outlined"
          row
          choices={TrueOrFalse}
          initialValue={false}
          validate={validateRequired}
        />
      </Grid>
      <Grid item xs={12}>
        <TextInput
          source="prompt"
          label="Glossary/Prompt"
          variant="outlined"
          multiline
          minRows={4}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6} align="left">
        <RadioButtonGroupInput
          source="active"
          label="Active"
          variant="outlined"
          row
          choices={ActiveTrueOrFalse}
          initialValue={"false"}
          validate={validateRequired}
        />
      </Grid>
    </Grid>
  );
};
